var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=ImportHistory, Property 2=Inactive"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.234 34.0565C30.234 33.8753 30.1847 33.6974 30.0915 33.542L25.8576 26.4857C25.5735 26.0121 24.9592 25.8585 24.4857 26.1427C24.3449 26.2271 24.2271 26.3449 24.1427 26.4857L19.9088 33.542C19.6247 34.0156 19.7783 34.6298 20.2518 34.914C20.4073 35.0072 20.5851 35.0565 20.7663 35.0565L23.001 35.0575L23.0002 42.0565C23.0002 42.6088 23.4479 43.0565 24.0002 43.0565H26.0002C26.5524 43.0565 27.0002 42.6088 27.0002 42.0565L27.001 35.0575L29.234 35.0565C29.7862 35.0565 30.234 34.6088 30.234 34.0565ZM14 7C18.4183 7 22 10.5817 22 15C22 19.4183 18.4183 23 14 23V21C17.3137 21 20 18.3137 20 15C20 11.6863 17.3137 9 14 9C10.6863 9 8 11.6863 8 15C8 15.3465 8.02936 15.6861 8.08574 16.0164L8.81453 14.9296L10.5 16L8.28679 19.4291L4 18L4.60308 16.0966L6.16267 16.613C6.05601 16.092 6 15.5525 6 15C6 10.5817 9.58172 7 14 7ZM15 10V13.878L18.3301 15.8L17.3301 17.5321L13 15.0321L13.017 15H13V10H15Z",
    fill: "#C3CBD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7967 15.3755L31.8162 15.4105L32.0336 15.4308C34.991 15.7447 37.0635 17.3067 38.0572 19.9968L38.0663 20.0255L38.1845 20.0445C41.4095 20.5885 43.6207 22.6178 44.6431 25.9685L44.7302 26.2676C46.2295 31.6649 41.6536 36.4695 36.9213 36.4695H31.6643V33.4695H36.9213C39.8175 33.4695 42.7592 30.3807 41.8397 27.0705C41.0875 24.3627 39.5084 23.0581 36.8381 22.9098L35.7263 22.848L35.4636 21.766C34.8954 19.425 33.4947 18.3718 30.8834 18.3718H29.8943L29.5047 17.4627C28.9203 16.0992 27.593 14.9764 25.9779 14.2758C25.9081 13.0883 25.6645 11.9465 25.2728 10.8761C28.0149 11.5772 30.4757 13.1863 31.7967 15.3755ZM7.8456 25.3037L7.7907 25.395C7.37706 26.1263 7.15625 27.0143 7.15625 28.0525C7.15625 31.7083 9.29104 33.4695 13.68 33.4695H17.9488L17.9488 36.4695H13.68C7.74794 36.4695 4.15625 33.5064 4.15625 28.0525C4.15625 26.2213 4.62598 24.6706 5.46064 23.4299C6.17089 24.1502 6.97224 24.7809 7.8456 25.3037Z",
    fill: "#E0E4E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportHistory);
export default __webpack_public_path__ + "static/media/importHistory.a208235f2e09d1b802ef80603aa4c6bb.svg";
export { ForwardRef as ReactComponent };